import React, {Component} from 'react';
import './Index.css'
import Header from '../../sharedcomponents/header/Index'
import SubNav2 from '../../sharedcomponents/header/SubNav2'
import Slide from '../../sharedcomponents/Slide/Slide';
import IntroHome from  '../../components/home/Intro.js';
import Parallax from '../../sharedcomponents/parallax/Parallax';
import Footer from '../../sharedcomponents/footer/Index.js';
import Services from '../../components/home/Services.js';
import ServicesProducts from '../../components/home/ServicesProducts.js';

export default class Home extends Component{
    
    render(){
    
        return(
            
            <div style={{maxWidth:'1920px'}}>
                <Header homeActive={"active"}/>
                <SubNav2/>
                <Parallax 
                    desc={'Imagine, crie, realize e imprime.'}
                />
                 <ServicesProducts/>
                 <div id="fisrtTitleHome" className="container" style={{paddingBottom:'50px', paddingTop:'-150px'}}>
                    <h2 className="text-center fist-title-home fist_title_home_mobile animated wow fadeInDown" style={{fontFamily: 'Myriad Pro Bold',fontWeight:'500', color:'#333'}}>
                    Descobra com HS Design uma maneira criativa e inteligente de imprimir o que precisa.&nbsp;&nbsp;
                     </h2>
                     <h4 className="text-center fist-title-home fist_title_home_mobile animated wow fadeInDown" style={{fontFamily: 'Myriad Pro Light',fontWeight:'bolder', color:'#333'}}>
                      Deixa o trabalho de gráfica connosco e desfruta de um mundo cheio de criatividade. HS Design é constituida por uma equipe altamente qualificada e criativa em design, impressões e muito mais.
                     </h4>
                </div>
                <Services/>
                <Slide/>
               <IntroHome/>
               <Footer/>
            </div>
        );
    }
}